import React from "react";

import error from "../images/404.svg";
import themisLogo from "../images/logo.svg";

function Error() {
  return (
    <div className="error-404">
      <a href="/">
        <img src={themisLogo} alt="themis-logo" />
      </a>
      <div className="error-404-wrap">
        <img src={error} alt="themis-logo" />
        <div className="error-404-block">
          <h3>Page Not Found</h3>
          <p>
            We can not seem to find the page you’re looking for, We suggest you
            go back while we look into it.
          </p>
          <a href="/">Go Back</a>
        </div>
      </div>
    </div>
  );
}

export default Error;
